<div class="page-container">
  <app-header></app-header>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>

<app-author-controls></app-author-controls>
